var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ArrowBack, InsertLinkOutlined } from "@mui/icons-material";
import { Box, Chip } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from "../../../assets/customIcons";
import { MuiIconButton } from "../../../builderPackage/components";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { showNotification } from "../../../redux/commonSlice";
import { useAppSelector } from "../../../store/hooks";
import { faintblue } from "../../../theme/palette";
import { systemColor } from "../../../theme/systemColor";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { getstockTransferRequisition } from "../../stockTransferRequistion/apiCall";
import StockAdjustmentRequistionPartDetails from "../../stockTransferRequistion/components/stockRequistionPartDetails";
import { StockTransferRequisitionAPIKeys } from "../../stockTransferRequistion/entity";
import { completedStockTransferRequisitionAPIGet, priorityListGet, stockTransferAttachmentDelete, stockTransferCreate, uploadStockTransferAttachment, warehouseListGet } from "../apiCall";
import { StockTransferAPIKeys } from "../entity";
import { GoogleAnlyticsErrorLog } from "../../../utils/utils";
export var CreateStockTransfer = function () {
    var _getLocalStorageItem, _getLocalStorageItem2, _crud$profilePersonal, _crud$profilePersonal2, _crud$profilePersonal3, _crud$profilePersonal4;
    var navigate = useNavigate();
    var _a = useState(false), priority = _a[0], setPriority = _a[1];
    var crud = useAppSelector(function (state) { return state.crud; });
    var isDisable = false;
    var dispatch = useDispatch();
    var searchParams = useSearchParams()[0];
    var mode = searchParams.get('mode');
    var id = useParams().id;
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var UserParentOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var warehouseList = function (params) { return warehouseListGet(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread(_objectSpread({}, params.request), {}, {
            TenantId: UserOrganization
        })
    })); };
    var stockRequisitionList = function (params) { return completedStockTransferRequisitionAPIGet(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread(_objectSpread({}, params.request), {}, {
            SourceTenantId: UserOrganization,
            SourceParentTenantId: UserParentOrganization,
            Key: "Completed",
            Type: "Requisition"
        })
    })); };
    var handleSearchClick = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getstockTransferRequisition({
                        request: {
                            id: value === null || value === void 0 ? void 0 : value.id
                        }
                    })];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && result.data) {
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                    }
                    else {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', "No requisition found");
                        dispatch(showNotification({
                            isOpen: true,
                            message: "No requisition found",
                            type: "error"
                        }));
                        return [2 /*return*/];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var step1 = [{
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            variant: 'outlined',
            title: 'Basic Details',
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'TransferRequisition ',
                    label: 'Transfer requisition ',
                    getListData: stockRequisitionList,
                    valueExpr: "id",
                    displayExpr: "DocumentCode",
                    required: false,
                    setFormState: function (formValues, currValue, field) { return __awaiter(void 0, void 0, void 0, function () {
                        var data;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, handleSearchClick(currValue)];
                                case 1:
                                    data = _a.sent();
                                    return [2 /*return*/, {
                                            SourceWarehouseId: data === null || data === void 0 ? void 0 : data.SourceWarehouseId,
                                            DestinationWarehouseId: data === null || data === void 0 ? void 0 : data.SourceWarehouseId,
                                            PriorityId: data.PriorityId,
                                            PriorityRemarks: data === null || data === void 0 ? void 0 : data.PriorityRemarks,
                                            StockTransferRequisitionDetail: data === null || data === void 0 ? void 0 : data.StockTransferRequisitionDetail
                                        }];
                            }
                        });
                    }); }
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'SourceWarehouseId',
                    label: 'Warehouse',
                    getListData: warehouseList,
                    required: true,
                    setFormState: function (value, currValue) {
                        return {
                            DestinationWarehouseId: currValue === null || currValue === void 0 ? void 0 : currValue.id
                        };
                    }
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'PriorityId',
                    label: 'Priority',
                    getListData: priorityListGet,
                    onChange: function (e, value) {
                        setPriority(value.Name === 'High');
                    }
                }, priority ? {
                    type: FormItemTypes.TextInput,
                    name: 'PriorityRemarks',
                    label: 'Priority reason',
                    multiline: true,
                    minRows: 2,
                    required: true,
                    placeholder: 'Enter priority reason'
                } : null]
        }, {
            type: FormItemTypes.Custom,
            name: "StockTransferRequisitionDetail",
            element: StockAdjustmentRequistionPartDetails,
            columnSize: 12
        }];
    var step2 = [{
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            variant: 'outlined',
            title: 'Notes & attachments',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: 'Notes & attachments',
                    label: 'Notes & attachments',
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.TextInput,
                            name: 'Transfer reasons',
                            label: 'Transfer reasons (0/200 characters)',
                            placeholder: 'Enter reasons',
                            md: 6,
                            multiline: true,
                            minRows: 2
                        }, {
                            type: FormItemTypes.Attachment,
                            name: 'Attachments',
                            label: 'Add attachments',
                            value: null,
                            placeholder: 'Upload Files',
                            inputProps: {
                                accept: 'application/*',
                                multiple: true
                            },
                            uploadAttachmentRequest: {
                                systemname: StockTransferRequisitionAPIKeys.AttachmentSystemName
                            },
                            uploadAttachmentAPI: uploadStockTransferAttachment,
                            deleteAttachmentAPI: stockTransferAttachmentDelete
                        }]
                }]
        }];
    var tabs = [{
            id: '0',
            label: 'General & part detail',
            elements: step1
        }, {
            id: '1',
            label: 'Additional information',
            elements: step2
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'pageHeader',
            label: '',
            value: null,
            columnSize: 12,
            justifyContent: 'space-between',
            alignItems: 'center',
            spacing: 0,
            columnSpacing: 1,
            p: 2,
            elements: [{
                    type: FormItemTypes.Custom,
                    name: '',
                    label: '',
                    value: null,
                    columnSize: 0,
                    element: function () { /*#__PURE__*/ return React.createElement(MuiIconButton, {
                        size: "small",
                        onClick: function () { return navigate('/stockTransfer'); }
                    }, " ", /*#__PURE__*/ React.createElement(ArrowBack, {
                        fontSize: "small"
                    }), " "); }
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    label: '',
                    value: null,
                    children: 'Create stock transfer',
                    columnSize: 0,
                    variant: 'h1',
                    noWrap: true
                }, mode !== "add" ? {
                    type: FormItemTypes.Custom,
                    name: '',
                    label: '',
                    value: null,
                    columnSize: 0,
                    element: function (props) {
                        var _props$value;
                        return /*#__PURE__*/ React.createElement(Chip, {
                            label: props === null || props === void 0 || (_props$value = props.value) === null || _props$value === void 0 || (_props$value = _props$value.Status) === null || _props$value === void 0 ? void 0 : _props$value.Name,
                            size: "small",
                            variant: "outlined",
                            sx: {
                                borderRadius: 2,
                                px: 1,
                                fontWeight: 'bold'
                            },
                            icon: /*#__PURE__*/ React.createElement(Box, {
                                height: 8,
                                width: 8,
                                borderRadius: 10,
                                bgcolor: "gray"
                            })
                        });
                    }
                } : null, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    label: '',
                    value: null,
                    columnSize: true,
                    item: false,
                    justifyContent: 'end',
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: '',
                            label: '',
                            value: null,
                            columnSize: 0,
                            children: '',
                            sx: {
                                color: 'gray'
                            }
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ActionPanel',
            columnSize: 12,
            spacing: 0,
            columnSpacing: 2,
            p: 2,
            minWidth: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignContent: 'flex-end',
            bgcolor: '#EFF2F5',
            setFieldProps: function (formValues, currValue) {
                return {
                    type: this.type,
                    display: {
                        xs: 'none',
                        sm: 'flex'
                    }
                };
            },
            elements: [{
                    type: FormItemTypes.Custom,
                    name: 'Menu',
                    label: '',
                    value: null,
                    columnSize: 0
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    item: false,
                    justifyContent: 'end',
                    spacing: 1,
                    elements: [{
                            type: FormItemTypes.Button,
                            name: '',
                            label: '',
                            value: null,
                            children: 'Quick Links',
                            disabled: true,
                            columnSize: 0,
                            variant: 'text',
                            startIcon: /*#__PURE__*/ React.createElement(InsertLinkOutlined, null),
                            sx: {
                                background: 'none'
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Box,
                            name: "",
                            columnSize: 0,
                            height: "40px",
                            width: "2px",
                            bgcolor: "rgba(0,0,0,0.1)",
                            mx: 1
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'Save',
                            columnSize: 0,
                            variant: 'contained',
                            disabled: isDisable,
                            onClick: function () { return 'submit'; }
                        }]
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: "Stepper",
            value: "0",
            tabs: tabs,
            valueExpr: "id",
            displayExpr: "label",
            variant: 'scrollable',
            columnSize: 12,
            tabPanelProps: {
                sx: {
                    px: {
                        xs: 2,
                        sm: 2.5,
                        md: 3
                    }
                }
            },
            sx: {
                paddingX: {
                    xs: 2,
                    sm: 2.5,
                    md: 3
                },
                gap: 2.5
            },
            stackContainerProps: {
                sx: {
                    mb: {
                        xs: 7.5,
                        sm: 0
                    }
                }
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ButtonContainer',
            spacing: 1,
            sx: {
                width: '100%',
                position: 'fixed',
                bottom: 0,
                paddingBottom: 2,
                paddingX: 2,
                right: 7,
                borderTop: "1px solid ".concat(systemColor.grey),
                justifyContent: 'flex-end',
                backgroundColor: '#FFFFFF',
                display: {
                    xs: 'flex',
                    sm: 'none'
                }
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Save',
                    columnSize: 0,
                    variant: 'contained',
                    disabled: isDisable,
                    onClick: function () { return 'submit'; }
                }],
            columnSize: 12
        }];
    var handleOnFormClose = function () {
        if (mode == "add") {
            dispatch(showNotification({
                isOpen: true,
                message: "Stock Transfer Created Successfully",
                type: "success"
            }));
        }
        else {
            dispatch(showNotification({
                isOpen: true,
                message: "Stock Transfer Updated Successfully",
                type: "success"
            }));
        }
        navigate("/stockTransfer");
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridSpacing: 2,
        formProps: {
            bgcolor: faintblue
        },
        getFormAPI: getstockTransferRequisition,
        getKey: StockTransferRequisitionAPIKeys.get,
        getRequest: {
            id: id
        },
        pagingAPIKey: StockTransferAPIKeys.paging,
        createKey: StockTransferAPIKeys.create,
        createFormAPI: stockTransferCreate,
        createRequest: {
            AssignTo: crud === null || crud === void 0 || (_crud$profilePersonal = crud.profilePersonalDetails) === null || _crud$profilePersonal === void 0 || (_crud$profilePersonal = _crud$profilePersonal.data) === null || _crud$profilePersonal === void 0 ? void 0 : _crud$profilePersonal.IdentityId,
            SourceTenantId: UserOrganization,
            SourceParentTenantId: UserParentOrganization,
            DestinationTenantId: UserOrganization,
            DestinationParentTenantId: UserParentOrganization,
            TotalQuantity: 0,
            TotalAmount: 0,
            RecordedBy: crud === null || crud === void 0 || (_crud$profilePersonal2 = crud.profilePersonalDetails) === null || _crud$profilePersonal2 === void 0 || (_crud$profilePersonal2 = _crud$profilePersonal2.data) === null || _crud$profilePersonal2 === void 0 ? void 0 : _crud$profilePersonal2.IdentityId,
            DocumentDate: new Date().toISOString(),
            RejectRemarks: "NA",
            Type: "StockTransfer",
            Status: "Draft"
        },
        updateRequest: {
            AssignTo: crud === null || crud === void 0 || (_crud$profilePersonal3 = crud.profilePersonalDetails) === null || _crud$profilePersonal3 === void 0 || (_crud$profilePersonal3 = _crud$profilePersonal3.data) === null || _crud$profilePersonal3 === void 0 ? void 0 : _crud$profilePersonal3.IdentityId,
            SourceTenantId: UserOrganization,
            SourceParentTenantId: UserParentOrganization,
            DestinationTenantId: UserOrganization,
            DestinationParentTenantId: UserParentOrganization,
            TotalQuantity: 0,
            TotalAmount: 0,
            RecordedBy: crud === null || crud === void 0 || (_crud$profilePersonal4 = crud.profilePersonalDetails) === null || _crud$profilePersonal4 === void 0 || (_crud$profilePersonal4 = _crud$profilePersonal4.data) === null || _crud$profilePersonal4 === void 0 ? void 0 : _crud$profilePersonal4.IdentityId,
            DocumentDate: new Date().toISOString(),
            RejectRemarks: "NA",
            Type: "StockTransfer",
            Status: "Draft"
        },
        updateFormAPI: stockTransferCreate,
        updateKey: StockTransferAPIKeys.update,
        onClose: handleOnFormClose
    }));
};
